import React from "react";
import LineChart from "../Chart/LineChart";

export default function ExpensesChart(props) {
  const chartDataPoints = [
    { label: "Jan", value: 0 },
    { label: "Feb", value: 0 },
    { label: "Mar", value: 0 },
    { label: "Apr", value: 0 },
    { label: "May", value: 0 },
    { label: "Jun", value: 0 },
    { label: "Jul", value: 0 },
    { label: "Aug", value: 0 },
    { label: "Sep", value: 0 },
    { label: "Oct", value: 0 },
    { label: "Nov", value: 0 },
    { label: "Dec", value: 0 },
  ];

  for (const expense of props.expenses) {
    const newDate = new Date(expense.date);
    const expenseMonth = newDate.getMonth(); // 0 => Jan      1 => Feb
    chartDataPoints[expenseMonth].value += +expense.amount;
  }
  console.log(chartDataPoints);
  return <LineChart data={chartDataPoints} />;
}
